import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoaderComponent } from '../../components/loader/loader.component';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    private dialogRef?: MatDialogRef<LoaderComponent>;

    constructor(private dialog: MatDialog) {}

    show(): void {
        if (!this.dialogRef) {
            this.dialogRef = this.dialog.open(LoaderComponent, {
                disableClose: true,
                panelClass: 'loader-panel',
            });
        }
    }

    hide(): void {
        this.dialogRef?.close();
        this.dialogRef = undefined;
    }
}
